import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./style.css";

function BusinessCardWhite() {
  return (
    <div className="bcw-page">
      <button
        className="bcw-print-btn no-print"
        onClick={() => window.print()}
      >
        Print / Save as PDF
      </button>

      <div className="bcw-card">
        <div className="bcw-sidebar">
          <img src="/img/logoFooter.svg" alt="Lozrian" className="bcw-logo" />
          <div className="bcw-sidebar-ring"></div>
        </div>

        <div className="bcw-main">
          <div className="bcw-content">
            <span className="bcw-tagline">Trading &amp; Business Solutions</span>
            <h1 className="bcw-name">Kateryna Shapoval</h1>
            <p className="bcw-title">Co-Founder &amp; Director</p>

            <div className="bcw-divider"></div>

            <div className="bcw-contact">
              <a href="tel:+380502484053" className="bcw-contact-item">
                <FaPhoneAlt />
                <span>+380 50 248 4053</span>
              </a>
              <a href="mailto:ks@lozrian.com" className="bcw-contact-item">
                <FaEnvelope />
                <span>ks@lozrian.com</span>
              </a>
            </div>
          </div>

          <div className="bcw-footer-bar">
            <span className="bcw-badge-label">Specialized Supply</span>
            <span className="bcw-badge-value">Global Marine Lubricants</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BusinessCardWhite;
